import React, { useRef } from "react";
import TimeOffSingle from "./singleView/View";

function TimeOffingle() {
    const componentRef = useRef(0);
    return (
        <div className="react-outeroi" ref={componentRef}>
            <TimeOffSingle />
        </div>
    )
}

export default TimeOffingle;